import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"font-size":"16px","padding":"0 0.4rem","line-height":"0.64rem"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_uf_form_item = _resolveComponent("uf-form-item")!
  const _component_choose_event_person = _resolveComponent("choose-event-person")!
  const _component_choose_person = _resolveComponent("choose-person")!
  const _component_SeePerson = _resolveComponent("SeePerson")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_uf_form_item, {
      title: _ctx.options.title,
      required: _ctx.options.is_checked == '1',
      readonly: _ctx.disabled
    }, {
      default: _withCtx(() => [
        (_ctx.isComponentType === 'Event' && _ctx.disabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (!Number(_ctx.options.is_radio))
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    (_ctx.options.user_info?.length)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          style: {"color":"#3d6eeb"},
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.seePersonShow = true))
                        }, " 查看更多 "))
                      : (_openBlock(), _createElementBlock("i", _hoisted_3, "-"))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    (_ctx.options.user_info?.length)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_5, _toDisplayString(_ctx.options.user_info[0].from_name) + " - " + _toDisplayString(_ctx.options.user_info[0].name), 1))
                      : (_openBlock(), _createElementBlock("i", _hoisted_6, "-"))
                  ]))
            ]))
          : (_openBlock(), _createBlock(_component_van_field, _mergeProps({
              key: 1,
              placeholder: "请选择",
              modelValue: _ctx.fieldValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fieldValue) = $event)),
              readonly: "",
              disabled: _ctx.disabled
            }, _ctx.$attrs, {
              "is-link": !_ctx.disabled,
              onClick: _ctx.onClick
            }), null, 16, ["modelValue", "disabled", "is-link", "onClick"]))
      ]),
      _: 1
    }, 8, ["title", "required", "readonly"]),
    (_ctx.isComponentType && _ctx.isComponentType === 'Event')
      ? (_openBlock(), _createBlock(_component_choose_event_person, {
          key: 0,
          show: _ctx.choosePersonShow,
          "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.choosePersonShow) = $event)),
          multiple: !_ctx.options.is_radio,
          ids: {
        user_ids: _ctx.options.user_ids,
        factory_ids: _ctx.options.factory_ids,
        stores_ids: _ctx.options.stores_ids
      },
          onConfirm: _ctx.onConfirm
        }, null, 8, ["show", "multiple", "ids", "onConfirm"]))
      : (_openBlock(), _createBlock(_component_choose_person, {
          key: 1,
          show: _ctx.choosePersonShow,
          "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.choosePersonShow) = $event)),
          multiple: !_ctx.options.is_radio,
          onConfirm: _ctx.onConfirm
        }, null, 8, ["show", "multiple", "onConfirm"])),
    _createVNode(_component_SeePerson, {
      show: _ctx.seePersonShow,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.seePersonShow) = $event)),
      data: _ctx.options
    }, null, 8, ["show", "data"])
  ], 64))
}